/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminResourcePagesModule} from '../common/controller/admin-resource-pages.module';
import {ListColumnSelectorComponent} from '../common/controller/list-column-selector.component';
import {QueryColumnSelectorComponent} from '../common/controller/query-column-selector.component';
import {ListSelectInFilterComponent} from '../common/directives/list-select-in-filter.component';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {AdminListModule} from '../common/directives/admin-list.module';
import {ChartsModule} from '../common/directives/charts.module';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {LineItemLabelsModule} from '../line-item/line-item-labels.module';
import {ReportListPageComponent} from './report-list-page.component';
import {ReportRoutePageComponent} from './report-route-page.component';
import {QueryRoutePageComponent} from './query/query-route-page.component';
import {QueryStatsTemplatePanelComponent} from './query/query-stats-template-panel.component';
import {ReportWidgetsModule} from './report-widgets.module';

const REPORT_PAGES = [
  QueryRoutePageComponent,
  QueryStatsTemplatePanelComponent,
  ReportListPageComponent,
  ReportRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule,
    AdminResourcePagesModule,
    AdnSelectComponent,
    ChartsModule,
    FormControlsModule,
    LineItemLabelsModule,
    ListColumnSelectorComponent,
    QueryColumnSelectorComponent,
    ListSelectInFilterComponent,
    ReportWidgetsModule
  ],
  declarations: REPORT_PAGES,
  exports: REPORT_PAGES
})
export class ReportPagesModule {
}
